import { VStack, Text } from '@cad-arc';
import { EntityTypes, Entity, MergedEntityTypes } from '../types';
import { SectionTitle } from '../../fr-event-common-components/section-title';
import { EntityCard } from '../../fr-event-common-components/fr-event-summary-entities-and-reports/components/entity-card';
import { CommonSize } from '../../common/helpers/utils';

export function PersonsOrVehiclesSection({
    title,
    entityType,
    mergedEntityType,
    entitiesList,
    mergedEntitiesList,
    dexDetails = true,
    size = 'sm',
    showViewOnMap = false,
}: {
    title: string;
    entityType: EntityTypes;
    mergedEntityType: MergedEntityTypes;
    entitiesList: Entity[];
    mergedEntitiesList?: Entity[];
    dexDetails?: boolean;
    size?: CommonSize;
    showViewOnMap?: boolean;
}) {
    return (
        <VStack alignItems="flex-start" w="100%">
            <SectionTitle title={title} />
            {entitiesList?.length > 0 &&
                entitiesList.map((entity, index) => {
                    return (
                        <EntityCard
                            key={entity['contextId']}
                            entity={entity}
                            type={entityType}
                            index={index}
                            showDexDetails={dexDetails}
                            size={size}
                            showViewOnMap={showViewOnMap}
                        />
                    );
                })}
            {mergedEntitiesList &&
                mergedEntitiesList?.length > 0 &&
                mergedEntitiesList.map((entity, index) => {
                    return (
                        <EntityCard
                            key={entity['contextId']}
                            entity={entity}
                            type={mergedEntityType}
                            index={index}
                            showDexDetails={dexDetails}
                            size={size}
                        />
                    );
                })}
            {!entitiesList?.length && !mergedEntitiesList?.length && (
                <Text fontSize={size} color="tertiary">
                    --
                </Text>
            )}
        </VStack>
    );
}
